module.exports = __webpack_public_path__ + "static/media/s.180d7f72.png";